import { render, staticRenderFns } from "./prolongaterequests.vue?vue&type=template&id=53b8246c"
import script from "./prolongaterequests.vue?vue&type=script&lang=js"
export * from "./prolongaterequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports